import { AuthUser } from './auth-user.model';

export class SignIn {
  static readonly type = '[Auth] SignIn';
  constructor(public returnUrl?: string) { }
}

export class SignInCallback {
  static readonly type = '[Auth] SignInCallback';
}

export class SignInSuccess {
  static readonly type = '[Auth] SignInSuccess';
  constructor(public user: AuthUser) { }
}

export class SignInFailure {
  static readonly type = '[Auth] SignInFailure';
  constructor(public error: any) { }
}

export class SignOut {
  static readonly type = '[Auth] SignOut';
}

export class SignOutSuccess {
  static readonly type = '[Auth] SignOutSuccess';
}

export class SessionFailure {
  static readonly type = '[Auth] SessionFailure';
  constructor(public error: any) { }
}

export class ResetPassword {
  static readonly type = '[Auth] ResetPassword';
  constructor(public returnUrl?: string) { }
}
